import { ConditionSet } from '@/types/conditional-rule'

export const CONDITION_LIST: { label: string; value: ConditionSet }[] = [
  { value: 'EQUALS', label: 'equals' },
  { value: 'NOT_EQUALS', label: 'does not equal' },
  { value: 'IS_FILLED', label: 'is filled' },
  { value: 'IS_EMPTY', label: 'is empty' },
  { value: 'CONTAINS', label: 'contains' },
  { value: 'NOT_CONTAINS', label: 'does not contain' },
  { value: 'CONTAINS_ANY', label: 'contains any of' },
  { value: 'NOT_CONTAINS_ANY', label: 'does not contain any of' },
  { value: 'GREATER_THAN', label: 'is greater than' },
  { value: 'LESS_THAN', label: 'is less than' },
  { value: 'IS_BEFORE', label: 'is before' },
  { value: 'IS_AFTER', label: 'is after' },
]
